import { Navigate } from 'react-router-dom'

// Authentication Pages
import Login from 'pages/Authentication/Login'
import Register from 'pages/Authentication/Register'
import ForgotPassword from 'pages/Authentication/ForgotPassword'

// Dashboard
import Dashboard from 'pages/Dashboard'

// Company
import CompanyProfile from 'pages/Company'

// Entity
import EntityManagement from 'pages/Entity'

// User
import UserManagement from 'pages/User'

// Truck
import TruckManagement from 'pages/Truck'

// Driver
import DriverManagement from 'pages/Driver'

// Transport Request
import TransportRequestList from 'pages/TransportRequest'
import RequestDetails from 'pages/TransportRequest/RequestDetails'
import MyProposals from 'pages/TransportRequest/MyProposals'
import AllProposals from 'pages/TransportRequest/AllProposals'
import MyNominations from 'pages/TransportRequest/MyNominations'
import AllNominations from 'pages/TransportRequest/AllNominations'
import NominateTruckPage from 'pages/TransportRequest/NominateTruckPage'

// Bilty
import BiltyList from 'pages/Bilty/BiltyList'
import BiltyDetails from 'pages/Bilty/BiltyDetails'

// Protected routes (require authentication)
const authProtectedRoutes = [
  { path: '/dashboard', component: <Dashboard /> },
  { path: '/company/profile', component: <CompanyProfile /> },
  { path: '/entity', component: <EntityManagement /> },
  { path: '/user', component: <UserManagement /> },
  { path: '/truck', component: <TruckManagement /> },
  { path: '/driver', component: <DriverManagement /> },
  { path: '/transport-request', component: <TransportRequestList /> },
  { path: '/transport-request/:id', component: <RequestDetails /> },
  { path: '/transport-request/:id/proposals', component: <MyProposals /> },
  { path: '/freight-proposal', component: <AllProposals /> },
  { path: '/truck-nomination', component: <AllNominations /> },
  { path: '/transport-request/:id/nominate', component: <NominateTruckPage /> },
  { path: '/transport-request/:id/nomination', component: <MyNominations /> },
  { path: '/bilty', component: <BiltyList /> },
  { path: '/bilty/:id', component: <BiltyDetails /> },

  // Default redirect
  {
    path: '/',
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
]

// Public routes (no authentication required)
const publicRoutes = [
  { path: '/login', component: <Login /> },
  { path: '/register', component: <Register /> },
  { path: '/forgot-password', component: <ForgotPassword /> },
]

export { authProtectedRoutes, publicRoutes }
